export const TAB_FABRICATION = 'pcbfabrication';
export const TAB_PCB_PARTS = 'pcbparts';
export const TAB_ASSEMBLY = 'pcbassembly';
